import AbstractNetworkStatus from '../all/AbstractNetworkStatus';

class PolaroidNetworkStatus extends AbstractNetworkStatus {
    constructor() {
        super();
    }
}

export default PolaroidNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/polaroid/NetworkStatus.js